<template>
  <div class="position-relative" v-click-outside="hide">
    <button v-if="isBulk" type="button" class="btn btn-primary width--100per d-block" :class="{'btn-secondary open': isOpen}" @click.prevent="show()">
      <i v-if="isRequest" class="fa fa-spinner fa-spin t-blue fa-spin-left t-xxs"></i><i v-else class="fa fa-plus t-sm pr-2"></i><span>Invite all to community</span>
    </button>

    <a v-else href="#" class="d-block block-fa clearfix width--100per" :class="{'open': isOpen}" @click.prevent="show()">
      <i class="fa fa-plus t-sm pr-3 t-secondary"></i>Invite to community
      <i class="t-black pt-1 fa pull-right" :class="{ 'fa-angle-down': !isOpen, 'fa-angle-up': isOpen }"></i>
    </a>

    <div v-if="isOpen" class="dropdown-menu-custom--left arrow-top-right px-2 py-2 box-shadow" aria-labelledby="invite-research_group-create">
      <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--65px`" />

      <div v-for="(community, index) in communities" :key="index">
        <a href="#" v-if="!community.invite" class="dropdown-item clearfix bd-radius px-2" @click.prevent="invite(community)">
          <span class="d-block t-600 t-overflow">{{ community.name }}</span>
        </a>

        <span v-if="community.invite" class="dropdown-item d-block px-2 clearfix bd-radius is-hover-disabled t-overflow">
          <i v-if="community.invite === 'pending'" class="fa fa-circle t-xs pr-1 t-yellow"></i>
          <i v-if="community.invite === 'confirmed'" class="fa fa-circle t-xs pr-1 t-green"></i>
          <i v-if="community.invite === 'declined'" class="fa fa-circle t-xs pr-1 t-red"></i>
          <span class="t-primary px-1">{{ community.name }}</span>
          <span v-if="community.invite === 'pending'" class="t-yellow">(pending)</span>
          <span v-if="community.invite === 'confirmed'" class="t-green">(already invited)</span>
          <span v-if="community.invite === 'declined'" clsas="t-red">(invite declined)</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'

import ResearcherService from '@/services/researcher'
import CommunityService from '@/services/community'

export default {
  name: 'inviteButtonCommunity',
  components: {
    Spinner
  },
  props: {
    researchGroup: {
      type: Object,
      required: false,
      default: () => ({})
    },
    researchGroupIds: {
      type: Array,
      required: false,
      default: () => ([])
    },
    isBulk: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isRequest: false,
      isLoaded: false,
      isOpen: false,
      communities: []
    }
  },
  methods: {
    hide () {
      this.isOpen = false
    },
    show () {
      if (!this.isOpen) {
        this.isOpen = true
        if (this.isEmpty(this.communities)) this.isLoaded = false

        !this.isBulk ? this.fetchWithResearchGroup() : this.fetch()
      } else {
        this.isLoaded = true
        this.isOpen = false
      }
    },
    fetchWithResearchGroup () {
      ResearcherService.getCommunitiesByResearchGroupId(this.$currentUser.slug_values[0], this.researchGroup.slug_values[0]).then(communities => {
        this.isLoaded = true
        this.communities = communities
      }).catch(err => {
        if (!err.message) {
          this.isLoaded = true
          this.$flash({ message: this.renderError(err) }, 'warning')
        }
      })
    },
    fetch () {
      ResearcherService.getCommunities(this.$currentUser.slug_values[0]).then(communities => {
        this.isLoaded = true
        this.communities = communities
      }).catch(err => {
        if (!err.message) {
          this.isLoaded = true
          this.$flash({ message: this.renderError(err) }, 'warning')
        }
      })
    },
    invite (community) {
      // TODO: Error handling
      if (!this.isBulk) {
        this.isOpen = false

        this.$can.edit('research_group', this.researchGroup.rw_access)
          ? this.$events.$emit('modal:invite:open:confirm', this.researchGroup, community)
          : this.$events.$emit('modal:invite:open:create', this.researchGroup, community)
      } else {
        if (!this.isRequest) {
          this.isRequest = true
          CommunityService.createResearchGroupInvite(community.slug_values[0], { research_group_ids: this.researchGroupIds }).then((invite) => {
            this.isOpen = false
            this.$flash({ message: `Successfully invited ${invite.invites.length} research groups` }, 'success')
            this.isRequest = false
          }).catch(err => {
            if (!err.message) {
              this.isOpen = false
              this.$flash({ message: this.renderError(err) }, 'warning')
              this.isRequest = false
            }
          })
        }
      }
    }
  }
}
</script>
